<template>
<div class="confirm-order-page page-with-tabbar">
    <van-nav-bar title="订单详情" fixed :placeholder="true" left-arrow @click-left="goBack" />
    <div class="order-detail-content">
        <!-- 订单卡片 -->
        <div class="main-card">
            <div class="card-header">
                <div class="title">{{ order.cinema_name }}</div>
                <div class="city">{{ order.city_name }}</div>
            </div>
            <div class="order-id-row">
                <span class="order-id">{{ order.order_id }}</span>
                <span class="copy-btn" @click="copyOrderId(order.order_id)">复制</span>
            </div>
            <div class="movie-info-row">
                <van-image width="80px" height="100px" fit="cover" :src="order.logo + '_200x200'" />
                <div class="movie-info-detail">
                    <div class="movie-title-row">
                        <div class="movie-title">{{ order.movie_name }}</div>
                        <span class="copy-order-btn" @click="copyOrder(order)">复制整单</span>
                    </div>
                    <div class="showtime-row">
                        <span class="today-tag" v-if="order.play_date_tag">{{ order.play_date_tag }}</span>
                        <span class="showtime">{{ order.play_time_text }}</span>
                    </div>
                    <div class="hall-name" v-if="order.hall_name">{{ order.hall_name }}</div>
                    <div class="movie-tags">
                        <span class="ticket-count">{{ order.quantity }}张</span>
                        <span v-if="order.support_exchange_seat === 'Y'" class="seat-type-tag">九宫格换座</span>
                        <span v-if="order.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                    </div>
                </div>
            </div>
            <div class="address-row">
                <van-icon name="location-o" class="address-icon" />
                {{ order.cinema_addr }}
            </div>
        </div>
        <!-- 价格信息 -->
        <div class="price-info">
            <div class="price-row">
                <span>市场价格：</span>
                <span class="price-value">￥{{ order.channel_price }}/张</span>
            </div>
            <div class="price-row">
                <span>报价价格：</span>
                <span class="price-value current-bid-price">￥{{ order.bid_price }}/张</span>
            </div>
            <div class="price-row">
                <span>订单结算：</span>
                <div>

                    <span class="order-total">￥{{ order.bid_amount }}</span><span class="order-total-desc">(￥{{ order.bid_price }}/张)</span>
                </div>
            </div>
        </div>
        <div class="decision-note">
            <van-icon name="info-o" />
            <span>确认前请确保可以正常出票，接单后将显示具体座位。</span>
        </div>
    </div>
    <!-- 底部操作栏 -->
    <div class="bottom-bar">
        <div class="bottom-actions">
            <van-button plain class="abandon-btn" :loading="abandoning" :disabled="isTimeExpired || confirming || abandoning" @click="abandonOrder">
                弃单
            </van-button>
            <van-button type="danger" block class="confirm-btn" :loading="confirming" :disabled="isTimeExpired || showDialog || confirming || abandoning" @click="showDialog = true">
                <div>
                    <span class="btn-text">确认接单</span>
                    <span class="countdown-inline">
                        <van-count-down v-if="remainingTime > 0" :time="remainingTime * 1000" format="(mm:ss)" class="countdown-inline-inner" @finish="onTimeExpired" />
                        <span v-else class="expired-text">已结束</span>
                    </span>
                </div>
            </van-button>
        </div>
    </div>
    <van-dialog v-model="showDialog" title="确认接单" show-cancel-button :close-on-click-overlay="false" :confirm-button-text="'确认接单'" :cancel-button-text="'取消'" @confirm="confirmOrder" @cancel="showDialog = false" class="confirm-order-dialog">
        <div class="dialog-content">请核实能正常出票后再确认接单</div>
    </van-dialog>
</div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import Api from '@/api-service';
export default {
    name: 'ConfirmOrder',
    data() {
        return {
            order: {},
            showDialog: false,
            isTimeExpired: false,
            confirming: false,
            abandoning: false
        };
    },
    created() {
        const orderStr = this.$route.query.order;
        if (orderStr) {
            try {
                this.order = JSON.parse(decodeURIComponent(orderStr));
                this.isTimeExpired = this.remainingTime <= 0;
            } catch (e) {
                Toast.fail('订单信息有误');
            }
        } else {
            Toast.fail('未获取到订单信息');
        }
    },

    computed: {
        remainingTime() {
            const hasDirectRemaining = this.order.remaining !== undefined && this.order.remaining !== null;
            const directRemaining = Number(this.order.remaining);
            if (hasDirectRemaining && Number.isFinite(directRemaining)) {
                return Math.max(0, Math.floor(directRemaining));
            }

            const rawExpiry = this.order.expire_time;
            if (!rawExpiry) return 0;
            let expiry = Number(rawExpiry);
            if (Number.isFinite(expiry)) {
                if (expiry < 1000000000000) expiry *= 1000;
            } else {
                expiry = new Date(rawExpiry).getTime();
            }
            if (!Number.isFinite(expiry)) return 0;
            return Math.max(0, Math.floor((expiry - Date.now()) / 1000));
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        async abandonOrder() {
            if (this.isTimeExpired || this.abandoning) return;

            try {
                await Dialog.confirm({
                    title: '确认弃单',
                    message: '弃单后本订单将转给其他商户，确定继续吗？',
                    confirmButtonText: '确定弃单',
                    cancelButtonText: '继续接单',
                    confirmButtonColor: '#e5484d'
                });
                this.abandoning = true;
                await Api.cancelOrder({
                    order_id: this.order.order_id
                });
                Toast.success('弃单成功');
                this.goBack(); // 弃单成功后返回到上一页
            } catch (e) {
                if (e !== 'cancel') Toast.fail(e && e.message ? e.message : '弃单失败');
            } finally {
                this.abandoning = false;
            }
        },
        onTimeExpired() {
            this.isTimeExpired = true;
        },
        copyOrderId(orderId) {
            if (!orderId) return;
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(orderId).then(() => {
                    Toast('复制成功');
                });
            }
        },
        async copyOrder(order) {
            // 组装订单主要信息
            const content = `
订单号：${order.order_id || ''}
城市：${order.city_name || ''}
影院名字：${order.cinema_name || ''}
影院地址：${order.cinema_addr || ''}
影片：${order.movie_name || ''}
场次：${order.play_time_text || ''}
影厅：${order.hall_name || ''}
市场价：${order.channel_price || ''}
`;
            try {
                await navigator.clipboard.writeText(content.trim());
                Toast.success('内容已复制到剪贴板');
            } catch (err) {
                Toast.fail('复制失败');
            }
        },
        formatTime(sec) {
            const m = String(Math.floor(sec / 60)).padStart(2, '0');
            const s = String(sec % 60).padStart(2, '0');
            return `${m}:${s}`;
        },
        async confirmOrder() {
            this.showDialog = false;
            if (this.confirming || this.isTimeExpired) return;
            this.confirming = true;
            try {
                await Api.confirmOrder({
                    order_id: this.order.order_id
                });
                Toast.success('确认接单成功');
                this.$router.replace({
                    name: 'UploadTicketCode',
                    query: {
                        order_id: this.order.order_id
                    }
                });
            } catch (e) {
                Toast.fail(e && e.message ? e.message : '确认接单失败');
            } finally {
                this.confirming = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.confirm-order-page {
    background: #f7f7fa;
    min-height: 100vh;
    padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));

    .order-detail-content {
        padding: 6px 12px 80px 12px;
    }

    .main-card {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .title {
                font-weight: bold;
                font-size: 16px;
                color: #222;
            }

            .city {
                font-size: 13px;
                color: black;
            }
        }

        .order-id-row {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #888;
            margin-top: 2px;

            .order-id {
                margin-right: 8px;
            }

            .copy-btn {
                color: #409eff;
                cursor: pointer;
            }
        }

        .movie-info-row {
            display: flex;
            align-items: flex-start;
            margin: 12px 0;

            .movie-info-detail {
                margin-left: 12px;
                flex: 1;

                .movie-title-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .movie-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #333;
                }

                .copy-order-btn {
                    margin-left: 12px;
                    font-size: 12px;
                    color: #888;
                    cursor: pointer;
                    align-self: center;
                }

                .showtime-row {
                    font-size: 13px;
                    color: #333;
                    margin: 8px 0;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .today-tag {
                    display: inline-block;
                    color: white;
                    background-color: #ff2c53da;
                    font-size: 12px;
                    font-weight: bold;
                    padding: 2px 6px 2px 4px;
                    margin-right: 2px;
                    line-height: 1.2;
                    vertical-align: middle;
                    border-radius: 2px;
                }

                .hall-name {
                    font-size: 13px;
                    color: #888;
                    margin-bottom: 2px;
                }

                .movie-tags {
                    margin-top: 4px;
                }

                .ticket-count {
                    background: #f7f8fa;
                    border-radius: 8px;
                    font-size: 10px;
                    padding: 1px 1px;
                }

                .seat-type-tag {
                    border: 2px solid rgb(0, 140, 255);
                    color: rgb(0, 140, 255);
                    border-radius: 2px;
                    font-size: 10px;
                    font-weight: bold;
                    padding: 2px 2px;
                    margin-left: 4px;
                }

                .couple-seat {
                    border: 2px solid #ff2c54;
                    color: #ff2c54;
                    background-color: #fff2f0;
                }
            }
        }

        .address-row {
            display: flex;
            align-items: center;
            font-size: 13px;
            color: #888;
            margin: 10px 0;

            .address-icon {
                font-size: 16px;
                color: #ff2c54;
                margin-right: 4px;
            }
        }
    }

    .price-info {
        background: #fff;
        border-radius: 8px;
        padding: 12px;
        margin: 8px 0;
        font-size: 14px;
        color: #333;

        .price-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 2px;
            font-size: 15px;

            .price-value {
                color: #222;
                font-weight: bold;
                margin-left: 8px;
            }

            .current-bid-price {
                color: #ff2c54;
            }

            .order-total {
                color: #ff2c54;
                font-weight: bold;
            }

            .order-total-desc {
                color: #888;
                font-weight: bold;
                margin-left: 2px;
            }
        }
    }

    .decision-note {
        display: flex;
        align-items: flex-start;
        gap: 7px;
        margin: 12px 0;
        padding: 11px 12px;
        border-radius: 10px;
        background: #fff7e8;
        color: #7a5617;
        font-size: 13px;
        line-height: 1.5;

        .van-icon {
            flex: none;
            margin-top: 3px;
        }
    }

    .bottom-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);
        z-index: 10;
        padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));

        .bottom-actions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            gap: 12px;
        }

        .abandon-btn {
            width: 76px;
            height: 46px;
            flex: none;
            border-color: #dfe4eb !important;
            color: #536171 !important;
        }

        .confirm-btn {
            flex: 1;
            height: 46px;
            font-size: 16px;
            font-weight: bold;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .btn-text {
            color: #fff;
            font-weight: bold;
            font-size: 16px;
        }

        .countdown-inline {
            display: inline-flex;
            align-items: center;
            margin-left: 8px;
        }

        .countdown-inline-inner {
            color: #fff !important;
            font-size: 16px;
            font-weight: bold;
            min-width: 48px;
            text-align: right;
        }

        .expired-text {
            color: #fff !important;
            font-size: 14px;
            font-weight: bold;
            min-width: 48px;
            text-align: right;
        }

    }

    .confirm-order-dialog .van-dialog__header {
        font-weight: bold;
        color: #1a2746;
    }

    .confirm-order-dialog .van-dialog__confirm {
        background: #ff2c54;
        color: #fff;
        font-weight: bold;
    }

    .confirm-order-dialog .van-dialog__cancel {
        color: #ff2c54;
        border: 1px solid #ff2c54;
        background: #fff;
        font-weight: bold;
    }

    .confirm-order-dialog .van-dialog__content {
        min-height: 120px;
        padding: 36px 16px 28px 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dialog-content {
        text-align: center;
        color: #333;
        font-size: 15px;
        margin: 12px 0 0 0;
    }
}
</style>
